// src/components/live-api/BotSpeakingIndicator.jsx
import React, {useEffect, useRef} from 'react';
import './audio-pulse.css';

const BAR_COUNT = 5;
const MAX_BAR_HEIGHT = 40; // px
const MIN_BAR_HEIGHT = 4;  // px

const AudioPulse = ({active, volume = 0}) => {
    const barsRef = useRef([]);

    useEffect(() => {
        if (active) {
            barsRef.current.forEach((bar, index) => {
                if (bar) {
                    // Calcular la altura de la barra basada en el volumen.
                    // Hacemos que las barras centrales sean un poco más reactivas o diferentes.
                    let sensitivity = 0.9; // Sensibilidad base
                    if (index === Math.floor(BAR_COUNT / 2)) { // Barra central
                        sensitivity = 1.5;
                    } else if (index === Math.floor(BAR_COUNT / 2) - 1 || index === Math.floor(BAR_COUNT / 2) + 1) { // Barras adyacentes a la central
                        sensitivity = 1.2;
                    }

                    const calculatedHeight = MIN_BAR_HEIGHT + (volume * (MAX_BAR_HEIGHT - MIN_BAR_HEIGHT) * sensitivity);
                    const height = Math.min(MAX_BAR_HEIGHT, Math.max(MIN_BAR_HEIGHT, calculatedHeight));
                    bar.style.height = `${height}px`;
                }
            });
        } else {
            // Si no está activo, resetear la altura de las barras
            barsRef.current.forEach(bar => {
                if (bar) {
                    bar.style.height = `${MIN_BAR_HEIGHT}px`;
                }
            });
        }
    }, [active, volume]); // Reaccionar a cambios en active y volume

    return (
        <div className={`bot-speaking-indicator-container ${active ? 'active' : ''}`}>
            {Array(BAR_COUNT).fill(null).map((_, i) => (
                <div
                    key={i}
                    className="bar"
                    ref={(el) => (barsRef.current[i] = el)}
                    // Los delays de animación CSS ya no son necesarios si la altura se controla por JS
                    // style={{ animationDelay: `${i * 133}ms` }}
                />
            ))}
        </div>
    );
};

export default AudioPulse;
